<template>
  <app-modal v-model="active" class="delete-modal">
    <div class="has-text-centered">
      <div class="icon" :class="iconClass"></div>
      <div class="delete-confirm-text">{{ title }}</div>
      <div class="delete-modal-actions">
        <button class="button is-secondary is-wide" @click="active = false">
          Cancel
        </button>
        <button class="button is-primary is-wide" @click="executeAction">
          {{ action }}
        </button>
      </div>
    </div>
  </app-modal>
</template>

<script>
import AppModal from './AppModal';

export default {
  name: 'ConfirmDialog',
  components: { AppModal },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Are you sure you want to delete?'
    },
    action: {
      type: String,
      default: 'Delete'
    },
    selected: {
      type: Object,
      default: null
    },
    iconClass: {
      type: String,
      default: 'icon-delete'
    }
  },
  data() {
    return {
      active: this.value
    };
  },
  watch: {
    active() {
      if (this.value !== this.active) {
        this.$emit('input', this.active);
      }
    },
    value() {
      if (this.value !== this.active) {
        this.active = this.value;
      }
    }
  },
  methods: {
    executeAction() {
      if (this.selected != null) this.$emit('confirmed', this.selected);
      else this.$emit('confirmed');
    }
  }
};
</script>

<style lang="scss">
.delete-modal {
  .modal-card {
    width: 60%;
    @include fullhd {
      width: 45%;
    }
  }
  .modal-card-body {
    padding-left: 0;
    padding-right: 0;
  }
  .icon {
    font-size: 3.5rem;
  }
  .delete-confirm-text {
    padding: 4rem 0 7rem;
    font-weight: $weight-bold;
    font-size: 2rem;
  }
  .delete-modal-actions {
    display: flex;
    justify-content: space-evenly;
  }
}
</style>
